export function wrappedDifference(target: number, current: number): number { return ((target - current + 540) % 360) - 180; }
export function gravityAngle(x: number, y: number, z: number, screenAngle: number): number | null {
  if (![x, y, z, screenAngle].every(Number.isFinite) || Math.abs(z) > 8 || Math.hypot(x, y) < 2) return null;
  return Math.atan2(x, y) * 180 / Math.PI + screenAngle;
}

export class Tilt {
  enabled = false;
  private current = 0;
  private target = 0;
  private frame = 0;
  reducedMotion = false;
  private readonly motion = (event: DeviceMotionEvent) => {
    const gravity = event.accelerationIncludingGravity;
    if (!gravity || gravity.x === null || gravity.y === null || gravity.z === null) return;
    const angle = gravityAngle(gravity.x, gravity.y, gravity.z, screen.orientation?.angle ?? 0);
    if (angle === null) return;
    this.target = angle;
    this.animate();
  };
  private animate(): void {
    if (this.frame || document.hidden) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      const desired = this.enabled ? this.target : 0;
      const difference = wrappedDifference(desired, this.current);
      this.current += this.reducedMotion ? difference : difference * 0.25;
      document.documentElement.style.setProperty('--letter-angle', `${this.current}deg`);
      if (Math.abs(difference) > 0.2) this.animate();
    });
  }
  async enable(): Promise<'enabled' | 'secure' | 'denied' | 'unavailable'> {
    if (!window.isSecureContext) return 'secure';
    if (!('DeviceMotionEvent' in window)) return 'unavailable';
    const motionClass = DeviceMotionEvent as typeof DeviceMotionEvent & { requestPermission?: () => Promise<string> };
    try {
      if (motionClass.requestPermission && await motionClass.requestPermission() !== 'granted') return 'denied';
      this.enabled = true;
      window.addEventListener('devicemotion', this.motion);
      return 'enabled';
    } catch { return 'denied'; }
  }
  disable(): void { this.enabled = false; window.removeEventListener('devicemotion', this.motion); this.animate(); }
  suspend(): void { window.removeEventListener('devicemotion', this.motion); cancelAnimationFrame(this.frame); this.frame = 0; }
  resume(): void { if (this.enabled) window.addEventListener('devicemotion', this.motion); this.animate(); }
}
